import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class WorkflowActionType extends Enum {
  key!: string;
  value!: string;

  static BULK_ASSIGNMENT: WorkflowActionType = {
    key: 'bulk_assignment',
    get value(): string {
      return Lang.t('workflow.bulk-assignment');
    }
  };

  static ROUND_ROBIN_ASSIGNMENT: WorkflowActionType = {
    key: 'round_robin_assignment',
    get value(): string {
      return Lang.t('workflow.round-robin');
    }
  };
}
